import { render, staticRenderFns } from "./lockedOut.vue?vue&type=template&id=9779c90e"
import script from "./lockedOut.vue?vue&type=script&lang=js"
export * from "./lockedOut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandingColoursCSS: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/BrandingColoursCSS.vue').default,SessionExpiry: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/SessionExpiry.vue').default,Notification: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Notification.vue').default})
